import { useIsMobile } from 'src/shared/hooks/use-mobile'

import AuthBackgroundImage from '/src/features/auth/assets/auth.png'
import MobileAuthBackgroundImage from '/src/features/auth/assets/mobile-auth.png'

const AuthBackground = () => {
  const isMobile = useIsMobile()

  if (isMobile) {
    return (
      <div className="flex w-screen items-center justify-center">
        <img
          src={MobileAuthBackgroundImage}
          alt="Mobile Auth Background"
          className="w-[90%] max-w-[600px] object-contain"
        />
      </div>
    )
  }

  return (
    <div className="flex h-[calc(100vh-128px)] w-full items-center justify-center">
      <img
        src={AuthBackgroundImage}
        alt="Auth Background"
        className="absolute bottom-[168px] right-20 object-contain"
        style={{
          minWidth: 1400,
          height: 900,
        }}
      />
    </div>
  )
}

export default AuthBackground
